import pluginMetadata from '../../plugin.json';

const PLUGIN_ID = 'kanban-board';

const normalizeLocale = locale => {
    if (typeof locale !== 'string' || locale.trim().length === 0) {
        return null;
    }

    return locale.trim().replace('-', '_');
};

export const getKanbanPluginRuntimeConfig = () => {
    if (typeof window === 'undefined') {
        return pluginMetadata.config || {};
    }

    return (
        window.chatwoot?.plugins?.[PLUGIN_ID]?.config || pluginMetadata.config || {}
    );
};

export const getOffersLabel = locale => {
    const config = getKanbanPluginRuntimeConfig();
    const labels = config.OFFERS_LABELS || {};
    const normalizedLocale = normalizeLocale(locale);
    const baseLocale = normalizedLocale?.split('_')[0] || null;

    return labels[normalizedLocale] || labels[baseLocale] || labels.default || '';
};
